<template>
    <div>
        <vs-alert v-if="onError" class="h-full mb-5" color="danger">
            <span>{{ errorMsg }}</span>
        </vs-alert>

        <div class="vx-row">
            <div class="vx-col w-full my-4">
                <h6>Ingresa la información:</h6>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-input
                class="w-full mb-4" 
                label="Nombre de la entidad certificadora"
                placeholder="Requerido"
                data-vv-name="certifyingEntity"
                v-model.lazy="name" />
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button @click="handleSave" :disabled="isSaveButtonDisabled" color="success" class="mr-5 mt-2">Guardar</vs-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreateCertifyingEntityModal',
    props: {
        itemsList: { type: Array, required: true }
    },
    data() {
        return {
            name: null,
            onError: false,
            errorMsg: null,
        };
    },
    computed: {
        isSaveButtonDisabled() {
            return this.name == null || !this.name.length;
        }
    },
    methods: {
        async handleSave() {
            this.onError = false;

            if(this.isItemDuplicated(this.name)) {
                this.onError = true;
                this.errorMsg = "Ya existe una unidad certificadora con el nombre " + this.name;
                this.showLoading(false);
                return;
            }

            this.showLoading(true);
            try {
                const {data} = await axios.post('api/v1/certifyingEntity', {
                    name: this.name
                });
                if(!data.success) {
                    this.onError = true;
                    this.errorMsg = data.message;
                    this.showLoading(false);
                    return;
                }
                this.name = null;
                this.$emit('on-save', data.message);
            } 
            catch (error) {
                console.log(error);
            }
        },
        isItemDuplicated(newItem) {
            const newItemName = newItem.toLowerCase().trim();

            for (const {name} of this.itemsList) {
                const existingItemName = name.toLowerCase().trim();
                if(existingItemName == newItemName)
                    return true;
            }
        }
    }
}
</script>